module.exports = __webpack_public_path__ + "static/media/StatsRadio_TheGuide_En.5549828b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/tutorials/assets/pdfs/en/StatsRadio_TheGuide_En.pdf
// module id = ./src/statsradio/modules/tutorials/assets/pdfs/en/StatsRadio_TheGuide_En.pdf
// module chunks = 18